import api from "./axios";

const educationApi = {
  getAll: () => api.get("/admin/education"),

  create: (data) => api.post("/admin/education", data),

  update: (id, data) => api.put(`/admin/education/${id}`, data),

  remove: (id) => api.delete(`/admin/education/${id}`),
};

export default educationApi;
